<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span>CONTENTS</h1>
</header>
<p class="tocfmf"><a class="xref" href="#/chifriedmancapitalism0007#fore">Foreword by Binyamin Appelbaum</a></p>
<p class="tocfm"><a class="xref" href="#/chifriedmancapitalism0008#pref-2002">Preface, 2002</a></p>
<p class="tocfm"><a class="xref" href="#/chifriedmancapitalism0009#pref-1982">Preface, 1982</a></p>
<p class="tocfm"><a class="xref" href="#/chifriedmancapitalism0010#pref-1962">Preface, 1962</a></p>
<p class="tocf"><a class="xref" href="#/chifriedmancapitalism0012#intro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/chifriedmancapitalism0013#ch01"><b>1</b>   The Relation between Economic Freedom and Political Freedom</a></p>
<p class="toc"><a class="xref" href="#/chifriedmancapitalism0014#ch02"><b>2</b>   The Role of Government in a Free Society</a></p>
<p class="toc"><a class="xref" href="#/chifriedmancapitalism0015#ch03"><b>3</b>   The Control of Money</a></p>
<p class="toc"><a class="xref" href="#/chifriedmancapitalism0016#ch04"><b>4</b>   International Financial and Trade Arrangements</a></p>
<p class="toc"><span aria-label="viii" class="page" id="pviii" role="doc-pagebreak"></span><a class="xref" href="#/chifriedmancapitalism0017#ch05"><b>5</b>   Fiscal Policy</a></p>
<p class="toc"><a class="xref" href="#/chifriedmancapitalism0018#ch06"><b>6</b>   The Role of Government in Education</a></p>
<p class="toc"><a class="xref" href="#/chifriedmancapitalism0019#ch07"><b>7</b>   Capitalism and Discrimination</a></p>
<p class="toc"><a class="xref" href="#/chifriedmancapitalism0020#ch08"><b>8</b>   Monopoly and the Social Responsibility of Business and Labor</a></p>
<p class="toc"><a class="xref" href="#/chifriedmancapitalism0021#ch09"><b>9</b>   Occupational Licensure</a></p>
<p class="toc"><a class="xref" href="#/chifriedmancapitalism0022#ch10"><b>10</b>   The Distribution of Income</a></p>
<p class="toc"><a class="xref" href="#/chifriedmancapitalism0023#ch11"><b>11</b>   Social Welfare Measures</a></p>
<p class="toc"><a class="xref" href="#/chifriedmancapitalism0024#ch12"><b>12</b>   The Alleviation of Poverty</a></p>
<p class="toc"><a class="xref" href="#/chifriedmancapitalism0025#ch13"><b>13</b>   Conclusion</a></p>
<p class="tocbmf"><a class="xref" href="#/chifriedmancapitalism0026#fn_notes">Footnotes</a></p>
<p class="tocbm"><a class="xref" href="#/chifriedmancapitalism0027#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-friedman-capitalism-0006.vue?07901e25